import { useRef, useState } from "react";
// @typescript-eslint/consistent-type-imports: type import にできない
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import Slider from "react-slick";
import { useSelector } from "store";

import type { EventGoodsItemSliderV2props } from "./eventGoodsItemSliderV2props";
import type { Settings } from "react-slick";

type Input = EventGoodsItemSliderV2props;

export const useEventGoodsItemSliderV2 = (input: Input) => {
  const { repGoods } = input;
  const isCapsuleGoodsSellingEnabled = useSelector(
    (state) => state.event?.displayEvent?.isCapsuleGoodsSellingEnabled
  );
  const [activeIndex, setActiveIndex] = useState(0);

  const thumbnailList = repGoods.classThumbnails ?? [repGoods.thumbnail];
  const capsuleThumbnail = repGoods.thumbnail;
  const settings: Settings = {
    beforeChange: (_currentSlide, nextSlide) => {
      setActiveIndex(nextSlide);
    },
    dots: true,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
  };
  const sliderRef = useRef<Slider | null>(null);
  const setSliderRef = (maybeSlider: Slider | null) => {
    sliderRef.current = maybeSlider;
  };
  const slickGoto = (index: number) => {
    sliderRef.current?.slickGoTo(index);
  };

  return {
    activeIndex,
    capsuleThumbnail,
    isCapsuleGoodsSellingEnabled,
    setSliderRef,
    settings,
    slickGoto,
    thumbnailList,
  };
};
